interface PageHeaderProps {
  title: string
}

export function PageHeader({ title }: PageHeaderProps) {
  return (
    <div
      className="pointer-events-none absolute top-0 right-0 left-0 z-10 px-6 pt-4 pb-10"
      style={{
        maskImage:
          'linear-gradient(to bottom, black 0%, black 40%, transparent 100%)',
        WebkitMaskImage:
          'linear-gradient(to bottom, black 0%, black 40%, transparent 100%)',
        backgroundColor: 'white',
      }}
    >
      <h1 className="text-center text-lg font-semibold leading-7 text-app-primary-900">
        {title}
      </h1>
    </div>
  )
}
